import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface AuthState {
  authType: "Outseta" | "MSAL"; // Type of authentication being used
  accessToken: string | null;
  tenantId: string | null;
  organizationId: string | null;
  accessTokens: { [key: string]: string };
}

const initialState: AuthState = {
  authType: "Outseta", // Default to Outseta, can be changed to MSAL
  accessToken: null,
  tenantId: null,
  organizationId: null,
  accessTokens: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthType: (state, action: PayloadAction<"Outseta" | "MSAL">) => {
      state.authType = action.payload;
    },
    setAccessToken: (state, action: PayloadAction<string | null>) => {
      state.accessToken = action.payload;
    },
    setTenantId: (state, action: PayloadAction<string | null>) => {
      state.tenantId = action.payload;
    },
    setOrganizationId: (state, action: PayloadAction<string | null>) => {
      state.organizationId = action.payload;
    },
    setAccessTokenForTenant: (
      state,
      action: PayloadAction<{ tenantId: string; accessToken: string }>
    ) => {
      state.accessTokens[action.payload.tenantId] = action.payload.accessToken;
    },
  },
});

export const hasAccessToken = (state: RootState) => !!state.auth.accessToken;
export const getAccessToken = (state: RootState) => state.auth.accessToken;
export const getTenantId = (state: RootState) => state.auth.tenantId;
export const getOrganizationId = (state: RootState) =>
  state.auth.organizationId;
export const getAccessTokenForTenant = (state: RootState, tenantId: string) => {
  // get the access token for the tenant
  const token = state.auth.accessTokens[tenantId];

  return token;
};

export const {
  setAuthType,
  setAccessToken,
  setTenantId,
  setOrganizationId,
  setAccessTokenForTenant,
} = authSlice.actions;

export default authSlice.reducer;
